import { IPetDataInputForm } from "../create-appointment-v2/create-appointment-v2.interface";
import { IPetItemResponse } from "../pet-list/pet-list.interface";
import { IAvailableTimeItemRequest } from "./available-times.interface";

export const mapToAvailableTimesRequest = (
  reasons: { [key: string]: IPetDataInputForm },
  selectedPets:IPetItemResponse[],
  date: string,
  locationId: number,
): IAvailableTimeItemRequest => {
  const pets = selectedPets.map((pet: IPetItemResponse) => {
    return {
      petId: pet.id,
      reasonsForVisit: "",
    };
  });

  // for (const key in reasons) {
  //   if (Object.prototype.hasOwnProperty.call(reasons, key)) {
  //     const element = reasons[key];

  //     pets.push({
  //       petId: key,
  //       reasonsForVisit: [element.reasons, element.anything]
  //         .filter((e) => e)
  //         .join(", "),
  //     });
  //   }
  // }

  return {
    pets,
    date,
    locationId,
  };
};

